{
  "schemaVersion": 1,
  "status": "local-conformance-passed",
  "tuple": {
    "schemaVersion": "2.0.0",
    "profile": "full-v1"
  },
  "authority": {
    "repository": "https://git.integrolabs.net/Fortemi/fortemi",
    "commit": "6343bd899958445bbc7e7e87b0dc92a8429d5a06",
    "contractSha256": "5bf8d2fd8147d8df92599b1a3ce6b405ce022c83893f37547aefa7ca659f0783",
    "schemaBundleSha256": "66dee80876c73fdc8756541c72e96ae189c098113a831c849d619381c4121c02"
  },
  "sourceFixture": {
    "path": "src/__tests__/shard/fixtures/full-v1/server-full-v1-revision-19.shard",
    "sha256": "c2e06eaa9802efd25ed70f5fe7e339548bd0b561ae86fb1a0f2d2fdf45305659"
  },
  "archive": {
    "path": "src/__tests__/shard/fixtures/full-v1/server-full-v1-revision-19-v2.shard",
    "bytes": 7088,
    "sha256": "054da5528276806b9be69dcfff364a6969b72344045f05f9f6fcbeaca82a7a59"
  },
  "implementation": {
    "scripts/generate-pglite-full-v1-receipt.mjs": "afb2216abd0c6cfccb61694ff20de92a353fe7d9db5f6aa364e971ceb214590c",
    "src/shard/full-v1-store.ts": "cc19742768a38f6966bdc3bdbfc352105d203ba0841036b9ce2b22ae11a5f320",
    "src/shard/live-full-v1.ts": "22f26caeaee929c941277a58c2afdaafc50410222febc84c9390713a3c414343",
    "src/shard/schema-validator.ts": "b45e349a43d472bfd0411adc4e87a2852ec43ad28f8a7ded64f0cca228c62c69",
    "src/shard/shard-import.ts": "71036913aa6d3b749bba1ef79ead1e5255026722fd5c2daf318efd3106cd5560",
    "src/shard/shard-export.ts": "c9898f68f74d8ae52180cb7d346df6720ff9f73f6b21780976e6db2568984397",
    "src/shard/profile-registry.ts": "ea4cdb7a3c865e1be6340a48cb13aeeb8849f47b31a1983d473834168f9e3ba6",
    "src/shard/shard-signature.ts": "fa3590f493e42edcf3a34fbdc62887eaf237f9e4563bbeb5b7fe7a8c57894070",
    "src/shard/blob-staging.ts": "1108e578a92466452f731838fb13077183a7a60bd6e7881d2b25708fb5185f97",
    "src/migrations/0020_full_v1_snapshot.ts": "54b5d47b521dc6fe44423b75f9032885e80f8e3fcbf04c11478baf98a9dc8841",
    "src/migrations/0022_embedding_config_timestamps.ts": "9e1de11f047cd1e071cc49d1ab231e5e4e01d5e80dda1ec63cb950e11adea0e0",
    "src/migrations/0023_source_metadata_purge.ts": "3afa0abb3ddb2d99a167102c9eb5d79eec98d638c03e9bead8ddb73a3ab812f4",
    "src/migrations/index.ts": "7d2dd6ddae84965c4e32039618f2fead9cf8c39d119823add3d2479d04615926",
    "src/__tests__/shard/full-v1-store.test.ts": "2ab75adcc64db605211e3b72d1288be0f77d137c1fbc876551cda73409396b84",
    "schemas/knowledge-shard-v2.schema.receipt.json": "70657d6bcd501b684d0a143bcbf7c2a0d41fe909ef3aff32b1fb1f542506a53a"
  },
  "evidence": {
    "command": "pnpm --filter @fortemi/core test:portable-contract",
    "assertions": [
      "all-33-components-persisted",
      "all-33-components-produced-from-live-pglite",
      "live-domain-relationships-materialized",
      "stable-live-identities-and-timestamps",
      "mandatory-blobs-reference-counted",
      "missing-live-blob-rejected",
      "invalid-source-signature-removed-after-manifest-rewrite",
      "valid-runtime-signature-retained",
      "live-runtime-signature-produced-and-verified",
      "unrepresentable-live-state-rejected-with-typed-loss",
      "validate-before-mutation",
      "repeat-import-converges",
      "exact-logical-files-reexported"
    ]
  }
}
